"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../../Button/Button");
var _PaymentError = require("../../PaymentError/PaymentError");
var _Icon = require("../../Icon/Icon");
var _payment = require("../../assets/icons/payment");
var _PaymentManualModule = _interopRequireDefault(require("../PaymentManual.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var bankColors = {
  Bog: '#FF671B',
  Tbc: '#00ABED',
  Lib: '#E70D2F'
};
var amountOptions = [40, 80, 120, 140];
var _default = function _default(_ref) {
  var platform = _ref.platform,
    actionType = _ref.actionType,
    cardOptions = _ref.cardOptions,
    error = _ref.error,
    callback = _ref.callback;
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    //remove amount suggestions on submit
    amountRef.current.blur();
    callback({
      cardId: event.target.cardId.value,
      amount: event.target.amount.value
    });
  };
  var cardRef = (0, _react.useRef)();
  var amountRef = (0, _react.useRef)();
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    as: _reactBootstrap.Form,
    noValidate: true,
    autoComplete: 'off',
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 5
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    className: _PaymentManualModule.default.dropdown,
    onSelect: function onSelect(value) {
      cardRef.current.value = value;
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentManualModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(platform === 'mob' ? _reactBootstrap.FloatingLabel : _react.default.Fragment, _objectSpread({}, platform === 'mob' && {
    label: 'ბარათი',
    style: {
      width: '100%',
      color: '#868895'
      /*color: !error.cardId ? '#868895' : 'var(--bs-danger)',*/
    },

    className: _PaymentManualModule.default.floatingLabel
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    isInvalid: !!error.cardId,
    name: 'cardId',
    ref: cardRef,
    disabled: true
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ''
  }, "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8"), /*#__PURE__*/_react.default.createElement("option", {
    value: '0'
  }, "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10D7"), /*#__PURE__*/_react.default.createElement("option", {
    value: '-1'
  }, "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"), cardOptions.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: item.id,
      value: item.id
    }, "**** **** **** ", item.digits);
  }))), platform === 'mob' && !!error.cardId && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.cardId))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: '0',
    as: 'span'
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    Icon: _payment.AddCard,
    style: {
      height: '1.7rem',
      width: '1.7rem',
      marginRight: '1rem'
    }
  }), "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10D7"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    eventKey: '-1',
    as: 'span'
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    Icon: _payment.NoAddCard,
    style: {
      height: '1.7rem',
      width: '1.7rem',
      marginRight: '1rem'
    }
  }), "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"), cardOptions.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      key: item.id,
      eventKey: item.id,
      as: 'span'
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      Icon: _payment.Card,
      type: 'vec',
      style: {
        height: '2rem',
        width: '2rem',
        marginRight: '1rem',
        backgroundColor: bankColors[item.bank]
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        paddingRight: '3rem'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "****"), /*#__PURE__*/_react.default.createElement("span", null, "****"), /*#__PURE__*/_react.default.createElement("span", null, "****"), /*#__PURE__*/_react.default.createElement("span", null, item.digits)));
  }))), platform === 'web' && /*#__PURE__*/_react.default.createElement(_PaymentError.PaymentError, {
    show: !!error.cardId,
    message: error.cardId
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 4,
    className: _PaymentManualModule.default.amountContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentManualModule.default.popover
  }, amountOptions.map(function (i) {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: i,
      type: 'button',
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        amountRef.current.value = i;
        e.target.blur();
      }
    }, i);
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentManualModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(platform === 'mob' ? _reactBootstrap.FloatingLabel : _react.default.Fragment, _objectSpread({}, platform === 'mob' && {
    label: 'თანხა',
    style: {
      width: '100%',
      color: '#868895'
      /*color: !error.amount ? '#868895' : 'var(--bs-danger)',*/
    },

    className: _PaymentManualModule.default.floatingLabel
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: 'number',
    placeholder: 'თანხა',
    isInvalid: !!error.amount,
    name: 'amount',
    ref: amountRef
  })), platform === 'mob' && !!error.amount && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.amount)), platform === 'web' && /*#__PURE__*/_react.default.createElement(_PaymentError.PaymentError, {
    show: !!error.amount,
    message: error.amount
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 3
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: actionType === 'deposit' ? 'success' : 'secondary',
    type: 'submit',
    style: actionType === 'withdraw' && {
      backgroundColor: '#435FA0',
      borderColor: '#435FA0'
    }
  }, actionType === 'deposit' ? 'შევსება' : 'გატანა')));
};
exports.default = _default;